<template>
  <div class="editable-span-container">
    <span class="editable-span"
          @click.stop="contentClick"
          ref="editableSpan"
          @keydown.enter="checkButtonClick"
          @keydown.escape="cancelButtonClick"
          tabindex="-1"
          @blur="blurContent"
    >
      <span
        class="contentText"
        :class="ellipsisClass()"
        :contenteditable="contentEditing"
        @blur="blurContent"
      >
        {{ content }}
      </span>
      <span class="actionIconsContainer ml-1">
        <v-icon
          small
          class="actionIcons acceptIcon"
          @click.stop="checkButtonClick"
        >
          check
        </v-icon>
        <v-icon
          small
          class="actionIcons cancelIcon"
          @click.stop="cancelButtonClick"
        >
          clear
        </v-icon>
      </span>
    </span>
  </div>
</template>

<script>
import { customSanitizeHtml } from '@/tools/htmlUtils';

export default {
  name: 'EditableSpan',

  props: {
    initialContent: {
      type: String,
      default: '',
    },
    ellipsisWhenShown: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      content: customSanitizeHtml(this.initialContent),
      contentEditing: false,
    };
  },

  computed: {
    contentEl() {
      return this.$refs.editableSpan.querySelector('.contentText');
    },
  },

  methods: {
    async contentClick() {
      if (!this.editable) return;

      this.contentEditing = true;
      this.savingContent = false;
      this.$refs.editableSpan.classList.add('focus');
      await this.$nextTick();
      this.contentEl.focus();
    },
    innerText() {
      return this.contentEl.innerText;
    },
    blurContent(event) {
      const inFocus = this.$refs.editableSpan.contains(event.relatedTarget);

      if (this.savingContent) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }

      if (inFocus) return;

      this.cancelButtonClick();
    },
    checkButtonClick(event) {
      event.preventDefault();

      this.content = customSanitizeHtml(this.innerText().trim());
      this.savingContent = true;
      this.$emit('contentUpdated', this.content);
      this.contentEditing = false;
      this.$refs.editableSpan.classList.remove('focus');
    },
    cancelButtonClick() {
      this.contentEl.innerText = this.initialContent;
      this.contentEditing = false;
      this.$refs.editableSpan.classList.remove('focus');
    },
    ellipsisClass() {
      if (!this.contentEditing && this.ellipsisWhenShown) {
        return 'text-ellipsis';
      }

      return '';
    },
  },
};
</script>

<style scoped>
.actionIcons {
  padding-left: 3px;
  transition: 0.2s linear;
}

.material-icons.acceptIcon {
  color: default;
}

.acceptIcon:focus,
.acceptIcon:hover {
  color: green;
}

.cancelIcon {
  color: default;
}

.cancelIcon:focus,
.cancelIcon:hover {
  color: red;
}

.editable-span-container {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  color: #232137;
  font-size: 15px;
  font-weight: 500;
  width: 100%;
}

.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.editable-span {
  display: flex;
  padding: 2px 8px;
  max-width: inherit;
  width: 100%;
  justify-content: space-between;
}

.editable-span .contentText {
  outline: none;
}

.editable-span.focus {
  cursor: text;
  padding: 2px 8px;
  border-radius: 4px;
  box-shadow: 0 0 3px 0 #BBB;
  z-index: 100;
}
.editable-span .actionIconsContainer {
  display: none;
  align-items: center;
}
.editable-span.focus .actionIconsContainer {
  display: flex;
}
</style>
